const ROLES = {
  ROLE_ADMIN: 'ROLE_ADMIN',
  ROLE_VERS_ADMIN: 'ROLE_VERS_ADMIN',
  ROLE_WORKSHOP_STAFF: 'ROLE_WORKSHOP_STAFF',
  ROLE_WORKSHOP_WAGON_QA: 'ROLE_WORKSHOP_WAGON_QA',
  ROLE_WORKSHOP_WHEELSET_QA: 'ROLE_WORKSHOP_WHEELSET_QA',
  ROLE_WORKSHOP_ADMIN: 'ROLE_WORKSHOP_ADMIN',
};
export default ROLES;
